import withErrorBoundary from 'components/shared/withErrorBoundary';
import { checkAHAVI } from 'utils/utils';
import { faRobot, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import { MainContext } from 'contexts/MainContext';

interface AiNotesProps {
  claudeRes: any;
  hidden: boolean;
  prewiew?: boolean;
}

const AiNotes: FC<AiNotesProps> = ({ claudeRes, hidden, prewiew }) => {
  const { t, i18n } = useTranslation();
  const { user } = useContext(MainContext);
  const [lang, setLang] = useState(i18n.language === 'he' ? 'he' : 'en');

  if (!user?.claudeAvailable) return null;
  return (
    <div>
      <div className={" details-block default-shadow mt-20" + (prewiew ? '' : 'details book ')}>
        <div className="title-underline text-lg mb-10 title-header-grey flex-row" style={{ alignItems: 'center' }}>{t('hotel.ai_notes')}
          <div className="flex-row ml-10">
            {claudeRes?.map((item: any) => (
              <div className="ph-5">

                <button
                  onClick={() => setLang(item.language)}
                  className={
                    'btn btn-default btn-xsm'
                  }
                >
                  <ReactCountryFlag svg countryCode={item.language_country_code.replace('GB', 'US')} className="mr-5" style={{ width: 14 }} />
                  {item.language?.toUpperCase()}
                </button>

              </div>

            ))}
          </div>
        </div>
        {!!claudeRes && !hidden && (
          <>

            {claudeRes[0].is_apartment && <div className="color-danger mb-20 text-bold text-lg">Apartment</div>}
            {claudeRes.filter((item: any) => item.language === lang).map((item: any) => (
              <div key={item.id} className="text-lh mb-20">
                {item.check_in_rules && <div dir={checkAHAVI(item.check_in_rules) ? 'rtl' : 'ltr'} dangerouslySetInnerHTML={{ __html: item.check_in_rules }}></div>}
              </div>
            ))}
          </>
        )}

        {!claudeRes && !hidden && (
          <div className="flex-center" style={{ padding: '40px 0' }}>
            <style>{`
              @keyframes zoomInOut {
                0%, 100% {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.3);
                }
              }
              .robot-loader {
                animation: zoomInOut 1.5s ease-in-out infinite;
              }
            `}</style>
            <FontAwesomeIcon
              icon={faRobot}
              size="2x"
              className="text-contrast robot-loader"
            />
          </div>
        )}

        {hidden && <div className="text-center text-bold  mt-20">No AI notes available</div>}
      </div>
    </div>
  );
};

export default withErrorBoundary(AiNotes, 'AiNotes');